import { useEffect, useState } from 'react';

export default function Geolocation() {
    const [location, setLocation] = useState({latitude: 0, longitude: 0});
    const [error, setError] = useState("");

    useEffect(() => {
        if (!navigator.geolocation) {
            setError('La geolocalización no es soportada por este navegador.');
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                setLocation({ latitude, longitude });
                localStorage.setItem('geolocation', JSON.stringify({'latitude': latitude, 'longitude': longitude}))
            },
            (err) => {
                setError(`Error al obtener ubicación: ${err.message}`);
            },
            {
                enableHighAccuracy: true, // usa GPS si está disponible
                timeout: 10000,
                maximumAge: 0,
            }
        );
    }, []);

    return (
        <div>
            {error && <p></p>}
            {location ? (
                <p></p>
            ) : (
                <p></p>
            )}
        </div>
    );
}
